module.exports = __webpack_public_path__ + "static/media/success-v2.044fda18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/success-v2.svg
// module id = 3283
// module chunks = 0